import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 border-t border-white/10" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="space-y-4">
            <img
              src="https://customer-assets.emergentagent.com/job_automation-core/artifacts/1jtkjchf_YTEK_logo-removebg-preview.png"
              alt="Ytek Controls"
              className="h-16 w-auto"
            />
            <p className="text-slate-400 text-sm leading-relaxed">
              Engineering Intelligence for Hydro Power. From Design to Commissioning.
            </p>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-white mb-4 uppercase tracking-wider text-sm">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-slate-400 hover:text-ocean-500 text-sm transition-colors" data-testid="footer-link-about">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-slate-400 hover:text-ocean-500 text-sm transition-colors" data-testid="footer-link-projects">
                  Projects
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-slate-400 hover:text-ocean-500 text-sm transition-colors" data-testid="footer-link-products">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-ocean-500 text-sm transition-colors" data-testid="footer-link-services">
                  Services
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-white mb-4 uppercase tracking-wider text-sm">
              Services
            </h3>
            <ul className="space-y-2">
              <li className="text-slate-400 text-sm">Hydro Power Design</li>
              <li className="text-slate-400 text-sm">Control Panels</li>
              <li className="text-slate-400 text-sm">SCADA & Automation</li>
              <li className="text-slate-400 text-sm">Commissioning</li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-white mb-4 uppercase tracking-wider text-sm">
              Contact
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-slate-400 text-sm">
                <MapPin size={16} className="mt-1 flex-shrink-0 text-ocean-500" />
                <span>Plot No.6 Kh No. 1044, Twin Industrial Estate, Central Hope Town, Selaqui, Dehradun</span>
              </li>
              <li className="flex items-center gap-2 text-slate-400 text-sm">
                <Phone size={16} className="flex-shrink-0 text-ocean-500" />
                <span>+91 94120 75715</span>
              </li>
              <li className="flex items-center gap-2 text-slate-400 text-sm">
                <Mail size={16} className="flex-shrink-0 text-ocean-500" />
                <span>info@ytekcontrols.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {new Date().getFullYear()} Ytek Controls. All rights reserved.
            </p>
            <div className="flex gap-6 items-center">
              <Link to="/privacy" className="text-slate-500 hover:text-ocean-500 text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-slate-500 hover:text-ocean-500 text-sm transition-colors">
                Terms of Service
              </Link>
              <Link to="/admin/login" className="text-slate-600 hover:text-slate-400 text-xs transition-colors" data-testid="footer-admin-link">
                ·
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
